
export type MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfoAllOfTwoType = typeof MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfoAllOfTwoType[keyof typeof MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingGetChatRooms200PageAllOfThreeContentItemBasicInfoAllOfTwoType = {
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
} as const;
